<table mdbTable #tableEl="mdbTable" class="z-depth-1">
  <thead>
    <tr>
      <th scope="col" [mdbTableSort]="data" sortBy="summary.purchasedAt">
        Purchase Date<mdb-icon fas icon="sort"></mdb-icon>
      </th>
      <th
        scope="col"
        *ngIf="auth.admin"
        [mdbTableSort]="data"
        sortBy="city.name"
      >
        City<mdb-icon fas icon="sort"></mdb-icon>
      </th>
      <th scope="col" [mdbTableSort]="data" sortBy="venue.name">
        Venue<mdb-icon fas icon="sort"></mdb-icon>
      </th>
      <th scope="col" [mdbTableSort]="data" sortBy="items[0].product.type">
        Product Type<mdb-icon fas icon="sort"></mdb-icon>
      </th>
      <th scope="col" [mdbTableSort]="data" sortBy="items[0].product.name">
        Pass Name<mdb-icon fas icon="sort"></mdb-icon>
      </th>
      <th scope="col" [mdbTableSort]="data" sortBy="items[0].event.date">
        Event Date<mdb-icon fas icon="sort"></mdb-icon>
      </th>
      <th scope="col" [mdbTableSort]="data" sortBy="user.name">
        Customer<mdb-icon fas icon="sort"></mdb-icon>
      </th>
      <th scope="col" [mdbTableSort]="data" sortBy="user.email">
        Email<mdb-icon fas icon="sort"></mdb-icon>
      </th>
      <th scope="col" [mdbTableSort]="data" sortBy="items[0].summary.units">
        Units<mdb-icon fas icon="sort"></mdb-icon>
      </th>
      <th scope="col" [mdbTableSort]="data" sortBy="summary.total">
        Total<mdb-icon fas icon="sort"></mdb-icon>
      </th>
      <th
        scope="col"
        [mdbTableSort]="data"
        sortBy="items[0].summary.redeemedAt"
      >
        Redeem Date<mdb-icon fas icon="sort"></mdb-icon>
      </th>
      <th scope="col">
        Redeemed?
      </th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let order of data; let i = index">
      <td scope="row" *ngIf="show(i)">
        {{ order.summary.purchasedAt.toDate() | date: "MM/dd/yy HH:mm" }}
      </td>
      <td *ngIf="auth.admin && show(i)">
        {{ order.city.name + ", " + order.city.state }}
      </td>
      <td *ngIf="show(i)">
        {{ order.venue.name }}
      </td>
      <td *ngIf="show(i)">
        {{ getType(order.items[0].product.type) }}
      </td>
      <td *ngIf="show(i)">
        {{ order.items[0].product.name }}
      </td>
      <td *ngIf="show(i)">
        {{ order.items[0].event.date.toDate() | date: "MM/dd/yy" }}
      </td>
      <td *ngIf="show(i)">
        {{ order.user.name }}
      </td>
      <td *ngIf="show(i)">
        <div *ngIf="!isAdmin">{{ mask(order.user.email) }}</div>
        <a *ngIf="isAdmin" [href]="mailTo(order.user.email)">{{
          order.user.email
        }}</a>
      </td>
      <td *ngIf="show(i)">
        {{ order.items[0].summary.units }}
      </td>
      <td *ngIf="show(i)">{{ order.summary.total | currency }}</td>
      <td *ngIf="order.items[0].summary.redeemedAt == null && show(i)">
        Not Redeemed
      </td>
      <td *ngIf="order.items[0].summary.redeemedAt != null && show(i)">
        {{
          order.items[0].summary.redeemedAt.toDate() | date: "MM/dd/yy HH:mm"
        }}
      </td>
      <td
        *ngIf="order.items[0].summary.redeemedAt == null && show(i)"
        class="not-redeemed"
      >
        <img
          height="16px"
          src="../../../../../assets/icons/circle.svg"
          class="clickable"
          (click)="redeem(order)"
        />
      </td>
      <td
        *ngIf="order.items[0].summary.redeemedAt != null && show(i)"
        class="redeemed"
      >
        <img
          height="16px"
          src="../../../../../assets/icons/check-circle.svg"
          class="clickable"
          (click)="redeem(order)"
        />
      </td>
    </tr>
  </tbody>
</table>
<div class="d-flex flex-row no-gutters  align-items-center">
  <div class="chip" mdbDropdown>
    <div class="btn-group" mdbDropdownToggle>
      {{ filter.showing }}
      <mdb-icon fas icon="chevron-down" class="close"></mdb-icon>
    </div>
    <div class="dropdown-menu dropdown-primary">
      <a
        class="dropdown-item"
        *ngFor="let item of filter.itemsPerPage"
        (click)="setItemsPerPage(item)"
        >{{ item }}</a
      >
    </div>
  </div>
  <label>per page</label>
  <div class="example-spacer"></div>
  <label 
    >{{ filter.firstIndex + 1 }} -
    {{ filter.lastIndex > data.length ? data.length : filter.lastIndex }} of 
    {{data.length | number}}
  </label>

  <button (click)="decrement()">
    <i class="fas fa-chevron-left grey-text"></i>
  </button>
  <button (click)="increment()">
    <i class="fas fa-chevron-right grey-text"></i>
  </button>
</div>
